module.exports = __webpack_public_path__ + "static/discount2-09e6a43e89dd954f606e1b7d0a7b18ac.jpg";